import { gql } from '@apollo/client'
import { ProjectRBACFragment } from '../fragments'

export const MUTATION_CONFIGURE_ORGANIZATION_RBAC = gql`
  mutation configureOrganizationUserRBAC($input: ConfigureOrganizationUserRBACInput!) {
    configureOrganizationUserRBAC(input: $input)
  }
`

export const MUTATION_DELETE_ORGANIZATION_RBAC = gql`
  mutation deleteOrganizationUserRBAC($input: DeleteOrganizationUserRBACInput!) {
    deleteOrganizationUserRBAC(input: $input)
  }
`

export const MUTATION_CONFIGURE_PROJECT_RBAC = gql`
  mutation configureProjectUserRBAC($input: ConfigureProjectUserRBACInput!) {
    configureProjectUserRBAC(input: $input) {
      ...ProjectRBACFragment
    }
  }
  ${ProjectRBACFragment}
`

export const MUTATION_DELETE_PROJECT_RBAC = gql`
  mutation deleteProjectUserRBAC($input: DeleteProjectUserRBACInput!) {
    deleteProjectUserRBAC(input: $input)
  }
`

export const MUTATION_DISABLE_PROJECT_RBAC = gql`
  mutation disableProjectUserRBAC($input: DisableProjectUserRBACInput!) {
    disableProjectUserRBAC(input: $input)
  }
`

export const MUTATION_ENABLE_PROJECT_RBAC = gql`
  mutation enableProjectUserRBAC($input: EnableProjectUserRBACInput!) {
    enableProjectUserRBAC(input: $input)
  }
`
